import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { TemplatesCreateFlexpayCreateScheduleControllerModule } from './controllers/TemplatesCreateFlexpayCreateScheduleController';

export const TemplatesCreateFlexpayCreateScheduleView = angular
  .module('acme.view.application.templates.create.flexpay.create.schedule', [
    uiRouter,
    'ui.bootstrap',
    TemplatesCreateFlexpayCreateScheduleControllerModule,
  ])

  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    $stateProvider.state({
      name: 'application.templates.create.flexpay.create.schedule',
      url: '/schedule',
      views: {
        'subview-main': {
          controller: 'TemplatesCreateFlexpayCreateScheduleController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/flexpay/create/schedule/schedule.tpl.html',
        },
      },
      data: {
        pageTitle: 'Create Event Template Flex Pay Schedule',
      },
    });

    $stateProvider.state({
      name: 'application.templates.edit.flexpay.create.schedule',
      url: '/schedule',
      views: {
        'subview-main': {
          controller: 'TemplatesCreateFlexpayCreateScheduleController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/flexpay/create/schedule/schedule.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Event Template Flex Pay Schedule',
      },
    });

    $stateProvider.state({
      name: 'application.templates.edit.flexpay.edit.schedule',
      url: '/schedule/:scheduleId',
      views: {
        'subview-main': {
          controller: 'TemplatesCreateFlexpayCreateScheduleController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/flexpay/create/schedule/schedule.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Event Template Flex Pay Schedule',
      },
    });
  }).name;
